<template>
  <div class="vehicle-form">
    <wrld-box :headerTitle="$t('overview')" hideableContent>
      <template v-slot:boxContent>
        <v-container>
          <VehicleFormOverview v-model="vehicle.overview" />
        </v-container>
      </template>
    </wrld-box>
    <!-- <wrld-box :headerTitle="$t('fleet.costs')" hideableContent>
      <template v-slot:boxContent>
        <v-container grid-list-xl>
          <VehicleFormCosts v-model="vehicle.costs"/>
        </v-container>
      </template>
    </wrld-box> -->
    <!-- <wrld-box :headerTitle="$t('fleet.permissions')" hideableContent>
      <template v-slot:boxContent>
        <v-container grid-list-xl>
          <VehicleFormPermissions v-model="vehicle"/>
        </v-container>
      </template>
    </wrld-box> -->
    <wrld-box :headerTitle="$t('fleet.properties')" hideableContent>
      <template v-slot:boxContent>
        <v-container>
          <VehicleFormProperties v-model="vehicle.properties"/>
        </v-container>
      </template>
    </wrld-box>
  </div>
</template>

<script>
import VehicleFormOverview from '@/components/fleet/VehicleFormOverview.vue'
// import VehicleFormCosts from '@/components/fleet/VehicleFormCosts.vue'
// import VehicleFormPermissions from '@/components/fleet/VehicleFormPermissions.vue'
import VehicleFormProperties from '@/components/fleet/VehicleFormProperties.vue'

export default {
  name: 'VehicleForm',
  components: {
    VehicleFormOverview,
    // VehicleFormCosts,
    // VehicleFormPermissions,
    VehicleFormProperties
  },
  props: {
    value: Object
  },
  data () {
    return {
      vehicle: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    vehicle: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
